import { FormControl, RadioGroup } from '@material-ui/core';

import { RadioOption, SideBarDialog } from 'shared/components';

import { useStoreSelector } from './hooks';

import makeClasses from './StoreSelector.style';

import type { Store, StoreId } from 'shared/domain';

export function StoreSelector(props: Props) {
  const { open, store, stores, onClose, changeStore } = props;
  if (isNaN(store.id)) return null;

  const {
    lang,
    selectedStoreId,
    handleOnChange,
    handleCTA,
  } = useStoreSelector({ open, storeId: store.id, onClose, changeStore });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      size='small'
      open={open}
      onClose={onClose}
      headerTitle={lang.header.title}
      actions={{
        primaryBtn: {
          children: lang.actions.primaryBtn,
          onClick: handleCTA,
        },
      }}
    >
      <FormControl
        component='fieldset'
        classes={{ root: _classes.formControl }}
      >
        <RadioGroup
          name='store-selector-menu-page'
          aria-label='store-selector'
          value={selectedStoreId}
          onChange={handleOnChange}
          className={_classes.radioGroup}
        >
          {stores.map(store => (
            <RadioOption key={store.id} value={store.id} title={store.name} />
          ))}
        </RadioGroup>
      </FormControl>
    </SideBarDialog>
  );
}

interface Props {
  open: boolean;
  store: Store;
  stores: Store[];
  onClose: () => void;
  changeStore: (id: StoreId) => void;
}
